import { VehicleService } from "../../../service/vehicle-service";

const fetchFAQ = (params) => () => {
    return new Promise((resolve, reject) => {
        VehicleService.fetchFaqs(params)
            .then(response => resolve(response.data.detail))
            .catch(error => reject(error));
    });
};

export {
    fetchFAQ
};
